import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Link, Box, Button } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import "../../../../../../../formLayout.scss";
import SelectDropdown from "../../../../../../../Supporting files/SelectDropdown/SelectDropdown";
import RKTextField from "../../../../../../../Supporting files/RKTextField/RKTextField";
import SearchDropdown from "../../../../../../../Supporting files/SearchDropdown/SearchDropdown";
function EditOrganisationDetails() {
  const navigate = useNavigate();
  const [organizationName, setOrganizationName] = React.useState("");
  const [industry, setIndustry] = React.useState("");
  const [url, setUrl] = React.useState("");
  const [userName, setUserName] = React.useState("");
  const [userID, setUserID] = React.useState("");
  const [designation, setDesignation] = React.useState("");
  const [emailID, setEmailID] = React.useState("");
  const [file, setFile] = React.useState("");
  const [taxId, setTaxId] = React.useState("");
  const [fiscalyear, setFiscalyear] = React.useState("");
  const [companyId, setCompanyId] = React.useState("");
  const [subindustry, setSubIndustry] = React.useState("");
  const [country, setCountry] = React.useState("");
  const [dateFormat, setDateFormat] = React.useState("");
  const [currency, setCurrency] = React.useState("");
  const [timeZone, setTimeZone] = React.useState("");
  const [report, setReport] = React.useState("");
  const [businessLocation, setBusinessLocation] = React.useState("");
  const [pincode, setPincode] = React.useState("");
  const [phoneNumber, setPhoneNumber] = React.useState("");
  const [mobile, setMobile] = React.useState("");
  const [address, setAddress] = React.useState("");

  const industry_data = [
    { key: "Engineering", value: "Engineering" },
    { key: "IT", value: "IT" },
    { key: "Human Resource", value: "Human Resource" },
    { key: "Business Development", value: "Business Development" },
    { key: "Designing", value: "Designing" },
    { key: "Management", value: "Management" },
  ];
  const sub_industry_data = [
    { key: "Engineering", value: "Engineering" },
    { key: "IT", value: "IT" },
    { key: "Human Resource", value: "Human Resource" },
    { key: "Business Development", value: "Business Development" },
    { key: "Designing", value: "Designing" },
    { key: "Management", value: "Management" },
  ];
  const fiscalyear_data = [
    { key: "Januray - December", value: "Januray - December" },
    { key: "February - January", value: "February - January" },
    { key: "April - March", value: "April - March" },
  ];
  const country_data = [
    { label: "India", value: "India" },
    { label: "Australia", value: "Australia" },
    { label: "England", value: "England" },
    { label: "New Zealand", value: "New Zealand" },
    { label: " South Africa", value: "South Africa" },
  ];
  const currency_data = [
    { label: "INR", value: "INR" },
    { label: "Dollar", value: "Dollar" },
    { label: "Euro", value: "Euro" },
    { label: "Dirham", value: "Dirham" },
    { label: "Dinar", value: "Dinar" },
  ];
  const timezone_data = [
    { label: "UTC+03:30  Iran ", value: "UTC+03:30  Iran " },
    { label: " UTC+04:00  Armenia ", value: " UTC+04:00  Armenia " },
    { label: "UTC+04:30  Afghanistan", value: "UTC+04:30  Afghanistan" },
    { label: " UTC+04:00  Armenia ", value: " UTC+04:00  Armenia " },
    { label: " UTC+05:30  INDIA ", value: " UTC+05:30  INDIA " },
  ];
  const dateformat_data = [
    { key: "DD/MM/YYYY", value: "DD/MM/YYYY" },
    { key: "YYYY/DD/MM", value: "YYYY/DD/MM" },
    { key: "DD-MM-YYYY", value: "DD-MM-YYYY" },
    { key: "YYYY-DD-MM", value: "YYYY-DD-MM" },
  ];
  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };
  function handleChange(e: any) {
    console.log(e.target.files);
    setFile(URL.createObjectURL(e.target.files[0]));
  }
  return (
    <Box className="layoutWrapper">
      {/* Page header */}
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={6} className="pageTitle">
          <Link
            className="backStep"
            onClick={() => {
              navigate("/SettingModuleForm?page=Modules&section=custom");
            }}
          >
            <ChevronLeftIcon />
          </Link>

          <div>
            <h3>Add Organisation Details</h3>
          </div>
        </Grid>
        <Grid xs={6}></Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid xs={12}>
          <Grid container spacing={3}>
            <Grid xs className="rightSection">
              <Box className="detailSection">
                <div className="sectionTitle">
                  <h4>Organisation Details</h4>
                </div>

                <Grid container spacing={3}>
                  <Grid xs={3} className="align-item-center">
                    <div className="profile_section">
                      <h6>Organization Logo</h6>
                      <div className="profile_inner_section">
                        <img
                          src={
                            file.length > 0
                              ? file
                              : "images/evervent_logo_one.svg"
                          }
                          alt=""
                          className="profile_logo"
                        />
                        <Link className="upload_img" component="label">
                          <input
                            hidden
                            accept="image/*"
                            multiple
                            type="file"
                            onChange={handleChange}
                          />
                          <img src="images/edit_image_icon.svg" alt="" />
                        </Link>
                      </div>
                    </div>
                  </Grid>
                  <Grid xs={9}>
                    <Grid container spacing={3}>
                      <Grid sm={4} md={4} lg={3} xl={4}>
                        <RKTextField
                          class_name="inputField"
                          title={"Organization Name"}
                          value={organizationName}
                          attrName={setOrganizationName}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid xs={4} md={4} lg={3} xl={4}>
                        <SelectDropdown
                          class_name="inputField"
                          title="Industry"
                          value={industry}
                          attrName={setIndustry}
                          value_update={updateMasterState}
                          dropdown_data={industry_data}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid xs={4} md={4} lg={3} xl={4}>
                        <SelectDropdown
                          class_name="inputField"
                          title="Sub-Industry"
                          value={subindustry}
                          attrName={setSubIndustry}
                          value_update={updateMasterState}
                          dropdown_data={sub_industry_data}
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid sm={4} md={4} lg={3} xl={3}>
                        <RKTextField
                          class_name="inputField"
                          title={"URL"}
                          value={url}
                          attrName={setUrl}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid sm={4} md={4} lg={3} xl={3}>
                        <RKTextField
                          class_name="inputField"
                          title={"Tax ID"}
                          value={taxId}
                          attrName={setTaxId}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid sm={4} md={4} lg={3} xl={3}>
                        <SelectDropdown
                          class_name="inputField"
                          title="Fiscal year"
                          value={fiscalyear}
                          attrName={setIndustry}
                          value_update={updateMasterState}
                          dropdown_data={fiscalyear_data}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid sm={4} md={4} lg={3} xl={3}>
                        <RKTextField
                          class_name="inputField"
                          title={"Company ID"}
                          value={companyId}
                          attrName={setCompanyId}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid sm={4} md={4} lg={3} xl={6}>
                        <RKTextField
                          class_name="inputField"
                          title={"Company ID"}
                          value={organizationName}
                          attrName={setOrganizationName}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid xs={4} md={4} lg={3} xl={6}>
                        <RKTextField
                          class_name="inputField"
                          title={"Email ID"}
                          value={organizationName}
                          attrName={setOrganizationName}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {/* Contact Info */}
                <Grid container spacing={3}>
                  <Grid xs={12}>
                    <h5 className="subHeading">Primary Contact</h5>
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid sm={6} md={4} lg={3} xl={3}>
                    <RKTextField
                      class_name="inputField"
                      title={"User ID"}
                      value={userID}
                      attrName={setUserID}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid sm={6} md={4} lg={3} xl={3}>
                    <RKTextField
                      class_name="inputField"
                      title={"Name"}
                      value={userName}
                      attrName={setUserName}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid sm={6} md={4} lg={3} xl={3}>
                    <RKTextField
                      class_name="inputField"
                      title={"Designation"}
                      value={designation}
                      attrName={setDesignation}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid sm={6} md={4} lg={3} xl={3}>
                    <RKTextField
                      class_name="inputField"
                      title={"Email ID"}
                      value={emailID}
                      attrName={setEmailID}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                </Grid>
                {/* Location Details */}
                <Grid container spacing={3}>
                  <Grid xs={12}>
                    <h5 className="subHeading">Locale Information</h5>
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid sm={6} md={4} lg={3} xl={3}>
                    <SearchDropdown
                      class_name="inputField"
                      title="Country"
                      value={country}
                      attrName={setCountry}
                      value_update={updateMasterState}
                      data={country_data}
                      warn_status={false}
                      error_message="Please select client"
                    />
                  </Grid>
                  <Grid sm={6} md={4} lg={3} xl={3}>
                    <SelectDropdown
                      class_name="inputField"
                      title="Date Format"
                      value={dateFormat}
                      attrName={setDateFormat}
                      value_update={updateMasterState}
                      dropdown_data={dateformat_data}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid sm={6} md={4} lg={3} xl={3}>
                    <SelectDropdown
                      class_name="inputField"
                      title="Currency (Base Currency)"
                      value={currency}
                      attrName={setCurrency}
                      value_update={updateMasterState}
                      dropdown_data={currency_data}
                      warn_status={false}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid sm={6} md={6} lg={6} xl={6}>
                    <SearchDropdown
                      class_name="inputField"
                      title="Time Zone"
                      value={timeZone}
                      attrName={setTimeZone}
                      value_update={updateMasterState}
                      data={timezone_data}
                      warn_status={false}
                      error_message="Please select client"
                    />
                  </Grid>
                  <Grid sm={6} md={6} lg={6} xl={6}>
                    <RKTextField
                      class_name="inputField"
                      title={"Report Basis"}
                      value={report}
                      attrName={setReport}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                </Grid>
                {/* Address Details */}
                <Grid container spacing={3}>
                  <Grid xs={12}>
                    <h5 className="subHeading">Address Details</h5>
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid sm={6} md={4} lg={4} xl={4}>
                    <RKTextField
                      class_name="inputField"
                      title={"Business Location"}
                      value={businessLocation}
                      attrName={setBusinessLocation}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>

                  <Grid sm={6} md={4} lg={4} xl={4}>
                    <RKTextField
                      class_name="inputField"
                      title={"Pincode"}
                      value={pincode}
                      attrName={setPincode}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid sm={6} md={4} lg={4} xl={4}>
                    <RKTextField
                      class_name="inputField"
                      title={"Phone Number"}
                      value={phoneNumber}
                      attrName={setPhoneNumber}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid sm={6} md={6} lg={6} xl={6}>
                    <RKTextField
                      class_name="inputField"
                      title={"Mobile Number"}
                      value={mobile}
                      attrName={setMobile}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid sm={6} md={6} lg={6} xl={6}>
                    <RKTextField
                      class_name="inputField"
                      title={"Address"}
                      value={address}
                      attrName={setAddress}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Footer Section */}
      <Grid container spacing={3} className="footerSection">
        <Grid xs={12} className="ctaBtn">
          <Button variant="contained" className="submitBtn">
            Save
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default EditOrganisationDetails;
